module.exports = __webpack_public_path__ + "img/icon_magnifying-glass.fdb1c68d.svg";